export const LIST_RESPONSIBLE_DOCTOR_SUMMARY_REQUEST = 'LIST_RESPONSIBLE_DOCTOR_SUMMARY_REQUEST'
export const LIST_RESPONSIBLE_DOCTOR_SUMMARY_SUCCESS = 'LIST_RESPONSIBLE_DOCTOR_SUMMARY_SUCCESS'
export const LIST_RESPONSIBLE_DOCTOR_SUMMARY_FAIL = 'LIST_RESPONSIBLE_DOCTOR_SUMMARY_FAIL'
export const LIST_RESPONSIBLE_DOCTOR_SUMMARY_RESET = 'LIST_RESPONSIBLE_DOCTOR_SUMMARY_RESET'

export const LIST_RESPONSIBLE_DOCTOR_REQUEST = 'LIST_RESPONSIBLE_DOCTOR_REQUEST'
export const LIST_RESPONSIBLE_DOCTOR_SUCCESS = 'LIST_RESPONSIBLE_DOCTOR_SUCCESS'
export const LIST_RESPONSIBLE_DOCTOR_FAIL = 'LIST_RESPONSIBLE_DOCTOR_FAIL'
export const LIST_RESPONSIBLE_DOCTOR_RESET = 'LIST_RESPONSIBLE_DOCTOR_RESET'

export const CREATE_RESPONSIBLE_DOCTOR_REQUEST = 'CREATE_RESPONSIBLE_DOCTOR_REQUEST'
export const CREATE_RESPONSIBLE_DOCTOR_SUCCESS = 'CREATE_RESPONSIBLE_DOCTOR_SUCCESS'
export const CREATE_RESPONSIBLE_DOCTOR_FAIL = 'CREATE_RESPONSIBLE_DOCTOR_FAIL'

export const DETAIL_RESPONSIBLE_DOCTOR_REQUEST = 'DETAIL_RESPONSIBLE_DOCTOR_REQUEST'
export const DETAIL_RESPONSIBLE_DOCTOR_SUCCESS = 'DETAIL_RESPONSIBLE_DOCTOR_SUCCESS'
export const DETAIL_RESPONSIBLE_DOCTOR_FAIL = 'DETAIL_RESPONSIBLE_DOCTOR_FAIL'

export const UPDATE_RESPONSIBLE_DOCTOR_REQUEST = 'UPDATE_RESPONSIBLE_DOCTOR_REQUEST'
export const UPDATE_RESPONSIBLE_DOCTOR_SUCCESS = 'UPDATE_RESPONSIBLE_DOCTOR_SUCCESS'
export const UPDATE_RESPONSIBLE_DOCTOR_FAIL = 'UPDATE_RESPONSIBLE_DOCTOR_FAIL'

export const DELETE_RESPONSIBLE_DOCTOR_REQUEST = 'DELETE_RESPONSIBLE_DOCTOR_REQUEST'
export const DELETE_RESPONSIBLE_DOCTOR_SUCCESS = 'DELETE_RESPONSIBLE_DOCTOR_SUCCESS'
export const DELETE_RESPONSIBLE_DOCTOR_FAIL = 'DELETE_RESPONSIBLE_DOCTOR_FAIL'

